import {
  IClickToCallConfigurations,
  IClickToCallConfigurationsCMS,
} from '@vfit/shared/data-access';
import { IProduct } from '@vfit/consumer/data-access';
import { ICMSError } from '@vfit/shared/models';

const getProductKey = (product: IProduct) => {
  return `${product?.cmsId}-${product?.category || product?.title} (${product?.hubPath})`;
};

const getProductByKey = (productKey: string, products: IProduct[]): IProduct | undefined => {
  return products?.find((p) => getProductKey(p) === productKey);
};

const getCtcKey = (
  ctc: IClickToCallConfigurations,
  isGlobalConfig?: boolean,
  type?: 'fixed' | 'mobile'
) => {
  if (isGlobalConfig) {
    return `${ctc?.key}-Configurazione globale ${type}`;
  }
  return `${ctc?.key}-Configurazione di prodotto`;
};

const getErrorsKeys = (cmsError: ICMSError[]): string[] => {
  return cmsError?.map((e) => {
    let error = `Errore: ${e.error} `;
    if (e?.errorCode) error += ` - Code: ${e.errorCode}`;
    error += ` - Ctc: ${e.keyClickToCall}`;
    return error;
  });
};

const getCtcByKey = (
  ctcKey: string,
  ctcGlobalFixedList: IClickToCallConfigurationsCMS,
  ctcGlobalMobileList: IClickToCallConfigurationsCMS,
  product?: IProduct
): IClickToCallConfigurations | undefined => {
  const ctcPKey = ctcKey?.split?.('-')?.[0];
  const isGlobal = ctcKey?.includes('globale');
  const isFixed = ctcKey?.includes('fixed');
  const globalApi = isFixed ? ctcGlobalFixedList : ctcGlobalMobileList;
  return (isGlobal ? globalApi : product)?.clicktocallconfigura?.elements?.find(
    (e) => e.key === ctcPKey
  );
};

export { getProductKey, getProductByKey, getCtcKey, getErrorsKeys, getCtcByKey };
